import { authenticatedGet } from "../../../api/authenticatedFetch";

const BASE_API = "/api/v1/forecast-predictability";

// getForecastPredictabilitySummary fetches the dashboard payload for a horizon.
// Returns the unwrapped summary object.
export const getForecastPredictabilitySummary = async (params = {}) => {
  const res = await authenticatedGet(`${BASE_API}/summary`, params);
  return res && res.summary ? res.summary : res;
};
